// 連想配列操作。viewへの通知のため、インスタンスを作り直す
export class MapHelper
{
    // クローンを作る
    public static clone(map : {}) : {}
    {
        var cloned = {};
        for(var key in map)
        {
            cloned[key] = map[key];
        }
        return cloned;
    }

    // 値を追加・置き換えて返す
    public static addOrReplace<T>(map : {}, key : any, item : T)
    {
        var cloned = this.clone(map);
        cloned[key] = item;
        return cloned;
    }

    // 値を削除して返す
    public static removeKey<T>(map : {}, key : any)
    {
        var cloned = this.clone(map);
        if(cloned[key]) { delete cloned[key]; }
        return cloned;
    }

    public static remove<T>(map : {}, item : T)
    {
        var cloned = {};
        for(var key in map)
        {
            if(map[key] != item)
            {
                cloned[key] = map[key];
            }
        }
        return cloned;
    }
}